"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listGenericTaggedValues = listGenericTaggedValues;
async function listGenericTaggedValues(params) {
    const request = {
        ...params,
    };
    return await this.sendRequest('/gtv/listGenericTaggedValue', request);
}
